// extracted by mini-css-extract-plugin
export var container = "intro-module--container--f390e";
export var content = "intro-module--content--a9784";
export var stat = "intro-module--stat--7385c";
export var statMetric = "intro-module--statMetric--23348";
export var statUnit = "intro-module--statUnit--faee1";
export var statsWrapper = "intro-module--statsWrapper--cf7e5";